import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import CenteredLoader from './CenteredLoader';

type PageStateProps = {
  loading?: boolean;
  error?: string | null;
  empty?: boolean;
  emptyMessage?: string;
  children: React.ReactNode;
};

export default function PageState({ loading, error, empty, emptyMessage, children }: PageStateProps) {
  if (loading) return <CenteredLoader />;
  if (error) {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        {error}
      </Alert>
    );
  }
  if (empty) {
    return (
      <Box sx={{ py: 6, textAlign: 'center' }}>
        <Typography sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
          {emptyMessage || 'Nothing to show.'}
        </Typography>
      </Box>
    );
  }
  return <>{children}</>;
}
